import React from "react";
import { FileText } from "lucide-react";

const TermsOfService = () => {
  return (
    <div className="bg-[#0C2340] p-2 md:!p-6 flex flex-col items-center">
      
      <div className="w-full bg-white/10 backdrop-blur-md shadow-xl rounded-2xl p-8 border border-white/20">
      <h1 className=" text-3xl md:text-3xl font-extrabold text-center mb-8 flex items-center text-blue-300">
        <FileText className="mr-3 text-blue-300" size={35} /> Terms of Service
      </h1>
        <p className="text-gray-100 text-lg leading-relaxed mb-6">
          By using our website and services, you agree to comply with our terms and conditions. These terms outline the rules and regulations for the use of our platform, ensuring a safe and transparent experience for all users.
        </p>
        <h2 className="text-2xl md:text-3xl font-bold text-blue-300 mb-4 border-b border-blue-300 pb-2">User Responsibilities</h2>
        <ul className="text-gray-100 text-lg leading-relaxed mb-6 list-disc pl-6">
          <li>Users must provide accurate and truthful information.</li>
          <li>Unauthorized access or misuse of the website is strictly prohibited.</li>
          <li>Users are responsible for maintaining the security of their accounts.</li>
        </ul>
        <h2 className="text-2xl md:text-3xl font-bold text-blue-300 mb-4 border-b border-blue-300 pb-2">Prohibited Activities</h2>
        <ul className="text-gray-100 text-lg leading-relaxed mb-6 list-disc pl-6">
          <li>Engaging in fraudulent, illegal, or deceptive activities.</li>
          <li>Violating intellectual property rights or distributing unauthorized content.</li>
          <li>Attempting to compromise website security or user data.</li>
        </ul>
        <h2 className="text-2xl md:text-3xl font-bold text-blue-300 mb-4 border-b border-blue-300 pb-2">Service Availability</h2>
        <p className="text-gray-100 text-lg leading-relaxed mb-6">
          We strive to maintain an uninterrupted service but do not guarantee constant availability. We reserve the right to modify, suspend, or discontinue any part of the service at our discretion.
        </p>
        <h2 className="text-2xl md:text-3xl font-bold text-blue-300 mb-4 border-b border-blue-300 pb-2">Limitation of Liability</h2>
        <p className="text-gray-100 text-lg leading-relaxed mb-6">
          We are not liable for any indirect, incidental, or consequential damages arising from the use of our services. Users assume full responsibility for their actions on our platform.
        </p>
        <h2 className="text-2xl md:text-3xl font-bold text-blue-300 mb-4 border-b border-blue-300 pb-2">Changes to Terms</h2>
        <p className="text-gray-100 text-lg leading-relaxed">
          We may update these Terms of Service from time to time. Changes will be posted on this page with an updated effective date. Users are encouraged to review these terms regularly to stay informed.
        </p>
      </div>
    </div>
  );
};

export default TermsOfService;
